export const STATUS_STYLES = {
    pending: { color: "#915800" },
    in_progress: { color: "#2196F3" },
    completed: { color: "#4CAF50" },
    partially_completed: { color: "#4CAF50" },
    done: { color: "#4CAF50" },
    delivered: { color: "#2E7D32" },
    accepted: { color: "#371addff" },
    partially_delivered: { color: "#66BB6A" },
    failed: { color: "#F44336" },
    delivery_failed: { color: "#C62828" },
    out_of_scope: { color: "#ff0000ff" }
};

export const STATUS_TAG_STYLES = {
    pending: { bg: "#FFF3CD", color: "#856404" },
    in_progress: { bg: "#D1ECF1", color: "#0C5460" },
    delivery_in_progress: { bg: "#D1ECF1", color: "#0C5460" },
    done: { bg: "#D4EDDA", color: "#155724" },
    completed: { bg: "#D4EDDA", color: "#155724" },
    partially_completed: { bg: "#D4EDDA", color: "#155724" },
    partially_delivered: { bg: "#D2FFCD", color: "#395715" },
    delivered: { bg: "#D2FFCD", color: "#395715" },
    accepted: { bg: "#c9c8f5ff", color: "#371addff" },
    failed: { bg: "#F8D7DA", color: "#721C24" },
    delivery_failed: { bg: "#F8D7DA", color: "#721C24" },
};


export const SUPER_ADMIN = "super-admin"

export const SUPPORTED_IMAGE_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/tif',
    'image/tiff'
    ];

export const isSupportedImage = (file) => {
        const mimeType = file.type?.toLowerCase();
        const extension = file.name.split('.').pop()?.toLowerCase();

        return (
            SUPPORTED_IMAGE_TYPES.includes(mimeType) ||
            (
                ['tif', 'tiff'].includes(extension) &&
                (!mimeType || ['application/octet-stream'].includes(mimeType))
            )
        );
    };